module.exports = function drawSpiral(ctx) {
  ctx.save();
  ctx.scale(0.5, 0.5);
  ctx.translate(620, 1750);
  ctx.scale(0.1, -0.1);
  ctx.fillStyle = '#fff';
  ctx.beginPath();
  ctx.moveTo(7221, 12785);
  ctx.bezierCurveTo(7099, 12758, 6957, 12672, 6883, 12582);
  ctx.bezierCurveTo(6760, 12431, 6712, 12221, 6760, 12036);
  ctx.bezierCurveTo(6789, 11923, 6833, 11846, 6920, 11759);
  ctx.bezierCurveTo(7009, 11670, 7043, 11650, 7237, 11574);
  ctx.bezierCurveTo(8275, 11170, 9110, 10532, 9772, 9640);
  ctx.bezierCurveTo(10308, 8917, 10686, 8010, 10814, 7135);
  ctx.bezierCurveTo(10864, 6801, 10884, 6307, 10861, 6000);
  ctx.bezierCurveTo(10748, 4481, 10024, 3152, 8816, 2245);
  ctx.bezierCurveTo(8111, 1717, 7275, 1376, 6415, 1266);
  ctx.bezierCurveTo(5999, 1213, 5497, 1220, 5090, 1286);
  ctx.bezierCurveTo(3911, 1475, 2877, 2097, 2150, 3055);
  ctx.bezierCurveTo(1680, 3674, 1371, 4418, 1266, 5185);
  ctx.bezierCurveTo(1207, 5616, 1222, 6123, 1305, 6546);
  ctx.bezierCurveTo(1550, 7785, 2340, 8821, 3477, 9394);
  ctx.bezierCurveTo(3890, 9602, 4287, 9723, 4790, 9792);
  ctx.bezierCurveTo(4939, 9812, 5512, 9809, 5665, 9787);
  ctx.bezierCurveTo(6654, 9643, 7441, 9190, 8036, 8420);
  ctx.bezierCurveTo(8369, 7989, 8616, 7424, 8703, 6890);
  ctx.bezierCurveTo(8758, 6557, 8758, 6167, 8704, 5852);
  ctx.bezierCurveTo(8560, 5010, 8094, 4297, 7384, 3830);
  ctx.bezierCurveTo(6577, 3299, 5602, 3207, 4770, 3584);
  ctx.bezierCurveTo(4107, 3883, 3596, 4498, 3415, 5210);
  ctx.bezierCurveTo(3366, 5404, 3356, 5491, 3356, 5730);
  ctx.bezierCurveTo(3356, 5977, 3366, 6064, 3421, 6269);
  ctx.bezierCurveTo(3605, 6963, 4157, 7501, 4844, 7655);
  ctx.bezierCurveTo(5532, 7809, 6206, 7504, 6503, 6905);
  ctx.bezierCurveTo(6650, 6607, 6673, 6301, 6569, 6016);
  ctx.bezierCurveTo(6463, 5726, 6194, 5502, 5903, 5460);
  ctx.bezierCurveTo(5837, 5451, 5719, 5457, 5721, 5469);
  ctx.bezierCurveTo(5721, 5472, 5757, 5492, 5801, 5513);
  ctx.bezierCurveTo(5911, 5566, 6004, 5659, 6059, 5772);
  ctx.bezierCurveTo(6116, 5888, 6132, 5955, 6137, 6106);
  ctx.bezierCurveTo(6142, 6229, 6140, 6243, 6112, 6342);
  ctx.bezierCurveTo(6031, 6626, 5801, 6828, 5485, 6891);
  ctx.bezierCurveTo(5385, 6911, 5174, 6908, 5072, 6886);
  ctx.bezierCurveTo(4912, 6852, 4779, 6796, 4665, 6715);
  ctx.bezierCurveTo(4591, 6663, 4457, 6525, 4403, 6445);
  ctx.bezierCurveTo(4074, 5959, 4147, 5286, 4585, 4777);
  ctx.bezierCurveTo(4817, 4507, 5172, 4315, 5555, 4250);
  ctx.bezierCurveTo(5669, 4230, 5708, 4228, 5880, 4233);
  ctx.bezierCurveTo(6140, 4241, 6295, 4273, 6544, 4372);
  ctx.bezierCurveTo(6945, 4531, 7321, 4853, 7549, 5233);
  ctx.bezierCurveTo(7708, 5497, 7815, 5820, 7850, 6139);
  ctx.bezierCurveTo(7876, 6373, 7851, 6710, 7791, 6948);
  ctx.bezierCurveTo(7598, 7702, 7050, 8355, 6340, 8676);
  ctx.bezierCurveTo(5839, 8902, 5282, 8974, 4730, 8884);
  ctx.bezierCurveTo(4096, 8780, 3481, 8452, 3013, 7967);
  ctx.bezierCurveTo(2522, 7459, 2227, 6820, 2139, 6075);
  ctx.bezierCurveTo(2122, 5939, 2122, 5531, 2138, 5395);
  ctx.bezierCurveTo(2222, 4685, 2481, 4063, 2925, 3510);
  ctx.bezierCurveTo(3547, 2734, 4447, 2249, 5455, 2145);
  ctx.bezierCurveTo(5717, 2118, 6109, 2127, 6385, 2166);
  ctx.bezierCurveTo(7410, 2311, 8379, 2869, 9041, 3696);
  ctx.bezierCurveTo(9240, 3943, 9364, 4136, 9510, 4425);
  ctx.bezierCurveTo(9769, 4936, 9911, 5443, 9961, 6028);
  ctx.bezierCurveTo(9978, 6233, 9967, 6709, 9941, 6905);
  ctx.bezierCurveTo(9819, 7816, 9470, 8614, 8881, 9329);
  ctx.bezierCurveTo(8677, 9577, 8346, 9890, 8064, 10102);
  ctx.bezierCurveTo(6944, 10947, 5442, 11244, 4035, 10900);
  ctx.bezierCurveTo(2823, 10603, 1759, 9890, 1014, 8875);
  ctx.bezierCurveTo(638, 8363, 344, 7744, 176, 7110);
  ctx.bezierCurveTo(-47, 6268, -56, 5345, 151, 4475);
  ctx.bezierCurveTo(466, 3144, 1261, 1946, 2370, 1128);
  ctx.bezierCurveTo(3158, 547, 4082, 177, 5060, 51);
  ctx.bezierCurveTo(5356, 12, 5471, 6, 5825, 6);
  ctx.bezierCurveTo(6353, 6, 6717, 48, 7215, 166);
  ctx.bezierCurveTo(8623, 501, 9877, 1311, 10780, 2470);
  ctx.bezierCurveTo(11467, 3352, 11911, 4431, 12049, 5555);
  ctx.bezierCurveTo(12086, 5853, 12095, 6001, 12095, 6355);
  ctx.bezierCurveTo(12095, 6799, 12068, 7110, 11994, 7515);
  ctx.bezierCurveTo(11583, 9768, 10054, 11699, 7965, 12602);
  ctx.bezierCurveTo(7814, 12668, 7604, 12750, 7520, 12777);
  ctx.bezierCurveTo(7453, 12798, 7297, 12802, 7221, 12785);
  ctx.closePath();
  ctx.fill();
  ctx.restore();
};
